// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".buttons[data-v-2f5fe289]{display:flex}a[data-v-2f5fe289]{margin-right:15px}a+.btn[data-v-2f5fe289]{padding-right:10px;padding-left:15px}", ""]);
// Exports
module.exports = exports;
